import React from 'react';
import { Link } from 'react-router-dom';
import { FaYoutube, FaInstagram, FaDumbbell, FaEnvelope, FaPhone, FaMapMarkerAlt, FaHeart } from 'react-icons/fa';

const Footer = ({ YOUTUBE_CHANNEL, INSTAGRAM_PROFILE }) => {
  return (
    <footer className="bg-black border-t-4 border-yellow-500 mt-8 sm:mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <FaDumbbell className="text-yellow-400 text-2xl" />
              <h3 className="text-xl font-bold text-yellow-400 uppercase">Coach Sabari</h3>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Professional fitness trainer dedicated to transforming lives through rugged training and personalized coaching.
            </p>
            <div className="flex space-x-4">
              <a
                href={YOUTUBE_CHANNEL}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-red-600 hover:bg-red-700 text-white p-3 rounded-lg transition-all transform hover:scale-110"
                title="YouTube"
              >
                <FaYoutube size={20} />
              </a>
              <a
                href={INSTAGRAM_PROFILE}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white p-3 rounded-lg transition-all transform hover:scale-110"
                title="Instagram"
              >
                <FaInstagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-yellow-400 uppercase mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                  About Me
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/workout-plans" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                  Workout Plans
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/community" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                  Community
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold text-orange-400 uppercase mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>• Personal Training</li>
              <li>• Online Coaching</li>
              <li>• Nutrition Planning</li>
              <li>• Workout Programs</li>
              <li>• BMI Analysis</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold text-red-400 uppercase mb-4">Contact</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start space-x-2">
                <FaEnvelope className="text-yellow-400 mt-1 flex-shrink-0" />
                <span>sabariprimefit@gmail.com</span>
              </li>
              <li className="flex items-start space-x-2">
                <FaPhone className="text-orange-400 mt-1 flex-shrink-0" />
                <span>+91 6383767287</span>
              </li>
              <li className="flex items-start space-x-2">
                <FaMapMarkerAlt className="text-red-400 mt-1 flex-shrink-0" />
                <span>Tamil Nadu, India</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-3 gap-3 sm:gap-4 py-4 sm:py-6 border-y border-gray-800 mb-4 sm:mb-6">
          <div className="text-center">
            <div className="text-xl sm:text-2xl font-bold text-yellow-400">380+</div>
            <div className="text-xs text-gray-500 uppercase">Subscribers</div>
          </div>
          <div className="text-center">
            <div className="text-xl sm:text-2xl font-bold text-orange-400">80+</div>
            <div className="text-xs text-gray-500 uppercase">Videos</div>
          </div>
          <div className="text-center">
            <div className="text-xl sm:text-2xl font-bold text-red-400">94K+</div>
            <div className="text-xs text-gray-500 uppercase">Views</div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="text-center">
          <p className="text-gray-500 text-sm mb-2">
            © {new Date().getFullYear()} Rugged Fitness Coach Sabari. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs flex items-center justify-center space-x-1">
            <span>Made with</span>
            <FaHeart className="text-red-500 animate-pulse" />
            <span>for Fitness Enthusiasts</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
